module.exports = __webpack_public_path__ + "img/icon-pain-4.29e54edf.png";